if(document.querySelectorAll('.sizes-switch__single.custom').length) {
  document.querySelectorAll('.sizes-switch__single.custom').forEach(function(btn) {
      btn.addEventListener('click', function() {
          document.querySelectorAll('.sizes-switch__single.custom').forEach(function(custom) {
              custom.classList.remove('active');
          });
          document.querySelectorAll('.single-size.custom').forEach(function(size) {
              size.classList.remove('active');
          });
          this.classList.add('active');
          if (this.classList.contains('inch')) {
              document.querySelector('.single-size.custom.inch').classList.add('active');
          } else {
              document.querySelector('.single-size.custom.cent').classList.add('active');
          }
      });
  });
}